import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Chart_Interface, Empty_Chart_Interface } from 'src/app/Interface/Chart_Interface';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-Chart_Co',
  templateUrl: './Chart_Co.component.html',
  styleUrls: ['./Chart_Co.component.scss']
})
export class Chart_CoComponent implements OnInit {

  @Input() inner_17025_Cat: Array<Chart_Interface> = []
  @Output() On_Add_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Edit_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Remove_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Remove_Person_Action = new EventEmitter<Persone_List_Interface>();
  @Output() On_Up_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Down_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Cut_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Person_Action = new EventEmitter<Chart_Interface>();
  @Output() On_Child_Action = new EventEmitter<Chart_Interface>();

  BaserUrlImage = environment.BaseUrl 

  constructor() { }

  ngOnInit() {
  }




  OnSet_Add_Action(item: Chart_Interface) {
    this.On_Add_Action.emit(item);
  }


  OnSet_Edit_Action(item: Chart_Interface) {
    this.On_Edit_Action.emit(item);
  }

  OnSet_Remove_Action(item: Chart_Interface) {
    this.On_Remove_Action.emit(item);
  }

  OnSet_Down_Action(item: Chart_Interface) {
    this.On_Down_Action.emit(item);
  }

  OnSet_Remove_Person_Action(item: Persone_List_Interface) {
    this.On_Remove_Person_Action.emit(item);
  }

  OnSet_Child_Action(item: Chart_Interface) {
    this.On_Child_Action.emit(item);
  }

  OnSet_Up_Action(item: Chart_Interface) {
    this.On_Up_Action.emit(item);
  }

  OnSet_Cut_Action(item: Chart_Interface) {
    this.On_Cut_Action.emit(item);
  }

  OnSet_Person_Action(item: Chart_Interface) {
    this.On_Person_Action.emit(item);
  }

  Change_Visible(item: Chart_Interface) {
    item.childVisible = !item.childVisible
  }

}
